var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("a-table", {
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.tableData,
          bordered: "",
          pagination: _vm.pagination,
          scroll: { y: 500 },
        },
        scopedSlots: _vm._u([
          {
            key: "name",
            fn: function (text) {
              return [_c("a", [_vm._v(_vm._s(text))])]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }